import React, {Component} from "react";
import {Container, Input, ListGroupItem} from 'reactstrap'
import {
    MDBListGroupItem, MDBInput, MDBInputGroup, MDBBtn, MDBListGroup, MDBNavLink,
    MDBContainer, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert
} from "mdbreact";
import firebase from "../../Config/firebase";
import classes from './ListReviewBox.module.css'
import {faComment, faImages, faPen, faReply, faSave, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ReplyReviewList from '../../Component/ReplyReviewList/ReplyReviewList'
import {isAuth} from "../../Utils/firebaseUtils";
import Select from "react-select";
import {ScrollableAnchor,goToAnchor} from 'react-scrollable-anchor'
import {timeStampToPostString} from "../../Utils/converter";
import ReviewHistory from "./ReviewHistory";


const db = firebase.firestore()


class ListReviewBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            isReply: false,
            postID: this.props.postID,
            content: this.props.data.content,
            review: this.props.data,
            reviewID:this.props.data.id,
            Replies: [],
            isLoaded: false,
            Reply: {
                content: '',
                createDate: new Date(),
                createUserName: '',
                createUserID: this.props.auth.uid,
                numOfReply: 0,
                isPublish: true,
                replyID:'',
                isEdit:false,
            },

            History:{
                createUserName:this.props.data.createUserName,
                reviewContent: this.props.data.content,
                createDate:new Date()
            },
            ReviewsHistory:[],
            toggleReply: false,
            isLoadingReply:false,
            replyCreateUserName:'',
            hasSelectedReplyID:true,
            isEdit:this.props.data.isEdit,
            isOpen: false,
            isEmpty:false,
        }
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.data !== nextProps.data) {
            this.setState({
                review: nextProps.data
            })
        }

    }

    delReview = (val) => {
        db.collection("Post").doc(this.props.postID).collection("Review").doc(val)
            .delete()
        this.props.delReview(val)
    }

    editReview = () => {
        this.setState({
            edit: true
        })
    }

    onChangeReview = (value) => {
        this.setState({
            content: value

        })
    }

    saveReview = () => {
        db.collection("Post")
            .doc(this.state.postID)
            .collection("Review")
            .doc(this.props.data.id)
            .update({content: this.state.content,isEdit:true})
            .then(data=>{
                this.setState({
                    isEdit:true
                })
            })

        this.setState({
            edit: false,
        })
    }


    openReply = () => {
        this.setState({
            toggleReply: true
        }, () => {
            console.log('in')
            this.getReplyByID()
        })
    }

    getSpecificReply = (val) =>{
        db.collection('Post').doc(this.props.postID)
            .collection('Review').doc(this.props.data.id)
            .collection('Reply')
            .where('replyID', "==", val)
            .get()
            .then(docs => {
                let allReply = []
                docs.forEach(function (doc) {
                    const Reply = {
                        id: doc.id,
                        ...doc.data()
                    }
                    allReply.push(Reply)
                })
                this.setState({
                    Replies: allReply
                })
            })
    }



    getReplyByID = () => {
        this.setState({
            isLoadingReply: true
        })

        db.collection('Post').doc(this.props.postID)
            .collection('Review').doc(this.props.data.id)
            .collection('Reply')
            .orderBy('createDate', 'asc')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allReply = []
                    docs.forEach(function (doc) {
                        const Reply = {
                            id: doc.id,
                            ...doc.data()
                        }
                        allReply.push(Reply)
                        console.log(allReply)
                    })

                    this.setState({
                        Replies: allReply,
                        isLoadingReply: false
                    }, () => {
                        this.setState({
                            isLoaded: true,
                        })
                    })

                    // allReply.forEach(function (Reply) {
                    //     if (typeof Reply.hasOwnProperty("replyID") !== 'undefined' && Reply.replyID !== '') {
                    //         if (allReply.includes((e) => e.id === Reply.replyID)) {
                    //             this.setState({
                    //                 Replies: allReply,
                    //                 isLoadingReply: false
                    //             }, () => {
                    //                 this.setState({
                    //                     isLoaded: true,
                    //                 })
                    //             })
                    //         } else {
                    //             db.collection('Post').doc(this.state.postID)
                    //                 .collection('Review').doc(this.state.data.id)
                    //                 .collection('Reply')
                    //                 .where('replyID', "==", Reply.replyID)
                    //                 .get()
                    //                 .then(docs => {
                    //                     docs.forEach(function (doc) {
                    //                         const Reply = {
                    //                             id: doc.id,
                    //                             ...doc.data()
                    //                         }
                    //                         allReply.push(Reply)
                    //                     })
                    //                     this.setState({
                    //                         Replies: allReply
                    //                     })
                    //                 })
                    //         }
                    //     }
                    // })

                }else {
                    this.setState({
                        Replies: [],
                        isLoaded: true
                    })
                }
            })
    }



    onReplyBox = (val) => {
        this.setState({
            Reply: {
                ...this.state.Reply,
                content: val
            }
        })
    }

    addReply = () => {
        if(this.state.Reply.content){
            const Reply = this.state.Reply
            db.collection("Post").doc(this.props.postID).collection("Review")
                .doc(this.props.data.id).collection('Reply')
                .add(Reply).then(doc => {
                const newReply = {
                    id: doc.id,
                    content: Reply.content,
                    createUserName: Reply.createUserName
                }
                this.setState({
                    Replies: this.state.Replies.concat(newReply),
                    Reply: {
                        content: '',
                        createDate: new Date(),
                        createUserID: this.props.auth.uid,
                        createUserName: Reply.createUserName,
                        numOfReply: 0,
                        isPublish: true,
                        replyReviewID: this.props.data.id,
                        isEdit:false
                    }
                })
            })

            db.collection("Post").doc(this.props.postID)
                .collection('Review').doc(this.props.data.id)
                .update({
                    numOfReply: firebase.firestore.FieldValue.increment(1),
                    lastReplyDate: new Date()
                })
        }else {
            this.setState({
                isEmpty:true
            })
        }
    }

    delReply = (val) => {
        let newReplies = this.state.Replies.filter(word => word.id !== val)
        this.setState({
            isLoaded: false
        }, () => {
            this.setState({
                Replies: newReplies
            }, () => {
                this.setState({
                    isLoaded: true
                })
            })
        })

        db.collection("Post").doc(this.props.postID)
            .collection('Review').doc(this.props.data.id)
            .update({
                numOfReply: firebase.firestore.FieldValue.increment(-1),
            })
    }

    onChangePostUserName = (userName) => {
        this.setState({
            post: {
                ...this.state.post,
                createUserName: userName
            }
        })
    }


    onChangeReplyUserName = (userName) => {
        this.setState({
            Reply: {
                ...this.state.Reply,
                createUserName: userName
            }
        })
    }

    newReply = (replyCreateUserName,replyID) =>{
        this.setState({
            Reply:{
                ...this.state.Reply,
                replyID: this.state.Reply.replyID === replyID ?
                    ''
                    : replyID
            },
            replyCreateUserName: this.state.replyCreateUserName === replyCreateUserName?
                ''
                : replyCreateUserName
        })
    }

    findReplyByReplyID = (replyID, replyreplyID) => {
        return new Promise((resolve, reject) => {
            if (Array.isArray(this.state.Replies)) {
                const matchReply = this.state.Replies.find(e => e.id === replyreplyID)
                if (typeof matchReply !== 'undefined' && matchReply !== null) {
                    return resolve({
                        success: true,
                        data: {
                            ...matchReply
                        }
                    })
                } else {
                    db.collection("Post")
                        .doc(this.state.postID)
                        .collection('Review')
                        .doc(this.state.reviewID)
                        .collection('reply')
                        .doc(replyreplyID)
                        .then(doc => {
                            if (doc.exists) {
                                return resolve({
                                    success: true,
                                    data: {
                                        ...doc.data(),
                                        id: doc.id
                                    }
                                })
                            } else {
                                return resolve({
                                    success: false,
                                    message: "reply not found"
                                })
                            }
                        })
                        .catch(err => console.log(err))
                }
            }
        })


    }

    addReviewHistory = () =>{
        const History = this.state.History
        db.collection("Post").doc(this.props.postID)
            .collection("Review").doc(this.state.reviewID)
            .collection('History')
            .add(History).then(doc => {
            const newReview = {
                id: doc.id,
                content: History.content,
            }
            this.setState({
                ReviewsHistory: this.state.ReviewsHistory.concat(newReview),
                History: {
                    createUserName:'',
                    reviewContent: '',
                    createDate: new Date(),
                }
            })
        })
    }

    changeOpen =()=>{
        this.setState({
            isOpen:true
        })
    }



    render() {
        return (
            <MDBListGroupItem className={classes.ListReviewBox}>

                <ReviewHistory
                    isOpen={this.state.isOpen}
                    postID={this.state.postID}
                    reviewID={this.state.reviewID}
                />

                <span className={classes.ReviewCreatedUser}>
                    {'@' + this.props.data.createUserName}
                    {
                        this.state.isEdit?
                            <MDBBtn
                                className={classes.isEditBtn}
                                color={"link"}
                                onClick={()=>
                                this.changeOpen()
                            }>
                                已編輯
                            </MDBBtn>
                            :''
                    }
                </span>
                <div className={["form-group", classes.ReviewInput].join(' ')}>
                    <MDBInput
                        name={'ReviewInput'} id={'ReviewInput'}
                        disabled={!this.state.edit}
                        onChange={(e) => this.onChangeReview(e.target.value)}
                        value={this.state.content}
                        label={this.state.edit ? "編輯回應" : ''}
                    />
                </div>
                {
                    isAuth(this.props.auth) &&
                    <button type="button" className={classes.ActionBtn}
                            onClick={(e) => this.openReply()}>
                        <FontAwesomeIcon icon={faReply}/>
                    </button>
                }


                {
                    this.props.auth.uid === this.props.data.createUserID ?
                        <div className={classes.ReviewOptionContainer}>
                            <button type="button" className={this.state.edit ? classes.ActionBtn : classes.Edit}
                                    onClick={(e) => {
                                        this.saveReview();
                                        this.addReviewHistory();
                                    }}>
                                <FontAwesomeIcon icon={faSave}/>
                            </button>
                            <button onClick={(e) => {
                                this.editReview();
                            }} className={classes.ActionBtn}>
                                <FontAwesomeIcon icon={faPen}/>
                            </button>
                            <button onClick={(e) => this.delReview(this.props.data.id)} className={classes.ActionBtn}>
                                <FontAwesomeIcon icon={faTrash}/>
                            </button>
                        </div> : ''
                }

                {
                    this.state.toggleReply && !this.state.isLoadingReply ?
                        <MDBListGroup>
                            {
                                this.state.Replies.map((Reply, index) => {
                                    return (
                                        <ReplyReviewList
                                            key={index}
                                            data={Reply}
                                            reviewID={this.state.reviewID}
                                            id={this.state.postID}
                                            auth={this.props.auth}
                                            delReply={this.delReply}
                                            newReply={this.newReply}
                                            isSelected={this.state.Reply.replyID === Reply.id}
                                            findReplyByReplyID={this.findReplyByReplyID}
                                        />
                                    )
                                })
                            }
                        </MDBListGroup>
                        :''
                }

                {
                    this.state.toggleReply && this.props.userName.length > 0 ?// !this.state.isLoadingReply
                        <div>

                            <div className={classes.AddReplyContainer}>
                               <span className={classes.ReplyTitle}>
                                    回覆 {"@" + this.state.replyCreateUserName}
                               </span>

                                {
                                    this.state.isEmpty?
                                        <MDBAlert color='danger'>
                                            請填寫回覆內容
                                        </MDBAlert>
                                        :''
                                }

                                <div className={classes.ReplyGrid}>
                                    <div>
                                        <span>選擇你的身份</span>
                                        <Select options={this.props.userName}
                                                className={classes.RoleSelection}
                                                value={{
                                                    label: this.state.Reply.createUserName,
                                                    value: this.state.Reply.createUserName
                                                }}
                                                onChange={(e) => this.onChangeReplyUserName(e.value)}/>
                                    </div>
                                    <div>
                                        <span>回應內容 </span>
                                        <input
                                            className="form-control"
                                            value={this.state.Reply.content}
                                            onChange={(e) => {
                                                this.onReplyBox(e.target.value)
                                                this.setState({
                                                    isEmpty:false
                                                })
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <MDBBtn color='primary'
                                                className={classes.SubmitCommentBtn}
                                                onClick={(e) => {
                                                    this.addReply();
                                                    this.openReply()
                                                }}>
                                            Submit
                                        </MDBBtn>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :""


                }

                {
                    this.props.data.hasOwnProperty('numOfReply') && this.props.data.numOfReply !== 0  && (this.props.data.numOfReply - this.state.Replies.length) > 0?
                        <button type="button" className={classes.ShowReplyBtn}
                                onClick={(e) => this.openReply()}>
                            {
                                this.state.isLoadingReply ?
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    :
                                    <div>
                                        顯示 {this.props.data.numOfReply - this.state.Replies.length} 回覆
                                    </div>
                            }
                        </button>
                        : ''
                }



            </MDBListGroupItem>
        );
    }
}

export default ListReviewBox